const convertDecimalToPercentValue = (value?: number | null) => {
  if (!value) {
    return 0;
  }
  return Math.round(value * 100);
};

export default convertDecimalToPercentValue;
